import * as React from "react";
import {observer} from "mobx-react";
import {
  List,
  ListHeading,
  ListHeadingCount,
  ListItems,
  ListItemEmpty,
} from "./components";
import {GenericListBoardCollection, ListBoardPropsList, ListBoardPropsRender} from "./types";
import {ListBoardItem} from "./item";
import {FaQuestionCircle} from "react-icons/fa";
import {Tooltip} from "../tooltip";

interface State {}

interface Props<T> extends ListBoardPropsRender<T> {
  data: GenericListBoardCollection<T>;
  list: ListBoardPropsList<T>;
}

@observer
export class ListBoardList<T> extends React.Component<Props<T>, State> {

  render() {

    const { list, data, renderIcon, renderRow, renderRowDropdown } = this.props;

    if (list.hide) return null;

    let items: T[] = [];
    if (data.lists[list.id]) {
      items = data.lists[list.id].items;
    }

    if (list.hideIfEmpty && items.length === 0) return null;

    return (
      <List>

        <ListHeading color={list.color}>
          <ListHeadingCount>
            {items.length}
          </ListHeadingCount>
          {list.title}
          {!!(list.tooltipContent && list.tooltipSize) && (
            <Tooltip text={list.tooltipContent} width={list.tooltipSize} position={"top"}>
              <FaQuestionCircle/>
            </Tooltip>
          )}
        </ListHeading>

        <ListItems>

          {items.map((item, z) => (
            <ListBoardItem<T>
              key={z}
              list={list}
              item={item}
              renderIcon={renderIcon}
              renderRow={renderRow}
              renderRowDropdown={renderRowDropdown}
            />
          ))}

          {items.length === 0 && (
            <ListItemEmpty>
              <p>Nothing here...</p>
            </ListItemEmpty>
          )}

        </ListItems>

      </List>
    );
  }

}
